<template>
  <div class="background">
    <div id="axis">
      <svg viewBox="0 0 628.2 18.53">
        <g v-for="tick in ticks" :key="tick.string">
          <line :x1="tick.x" y1="14" :x2="tick.x" y2="18.53" stroke="black" />
          <line :x1="tick.x" y1="0" :x2="tick.x" y2="5" stroke="black" />
          <text
            :x="tick.x"
            y="13"
            font-size="13"
            text-anchor="middle"
            background-color="white"
          >
            {{ tick.string }}
          </text>
        </g>
      </svg>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SimpleTimeAxis',
  props: {
    startTime: {
      type: Date,
      required: true
    },
    endTime: {
      type: Date,
      required: true
    }
  },
  computed: {
    ticks() {
      if (this.endTime == null || this.startTime == null) return
      let EndTime = this.endTime
      let StartTime = this.startTime
      let Width = 628.2
      let pastIncrement // milliseconds

      // Tick spacing
      let hoursBetween = (EndTime - StartTime) / (1000 * 3600)
      if (hoursBetween < 0.25) {
        pastIncrement = 2 * 60 * 1000
      } else if (hoursBetween < 0.5) {
        pastIncrement = 5 * 60 * 1000
      } else if (hoursBetween < 1) {
        pastIncrement = 15 * 60 * 1000
      } else if (hoursBetween < 2) {
        pastIncrement = 30 * 60 * 1000
      } else {
        pastIncrement = 60 * 60 * 1000
      }

      // Time Axis Ticks
      let pastAxisTimeSpan = EndTime - StartTime
      let startTimeTrimmed = new Date(
        StartTime.getTime() + (-StartTime.getTime() % pastIncrement)
      )
      let timesBetweenList = []
      for (let i = 0; i <= Math.round(pastAxisTimeSpan / pastIncrement); i++) {
        timesBetweenList.push(
          new Date(startTimeTrimmed.getTime() + i * pastIncrement)
        )
      }

      // Scale Axis
      let pastAxisLength = Width

      // Past Axis
      let ticks = []
      for (const time of timesBetweenList) {
        let labelDatetime = this.makeTimeString(time)
        let x = ((time - StartTime) / pastAxisTimeSpan) * pastAxisLength
        ticks.push({
          string: labelDatetime,
          x: x
        })
      }
      return ticks
    }
  },
  methods: {
    makeTimeString(date) {
      let hour = date.getHours()
      let minute = date.getMinutes()
      return this.makeDoubleDigit(hour) + ':' + this.makeDoubleDigit(minute)
    },
    makeDoubleDigit(x) {
      return x < 10 ? '0' + x : x
    }
  }
}
</script>

<style scoped>
.background {
  border-color: #979797;
  display: grid;
}
#axis {
  grid-row: 2;
  grid-column: 1;
  margin-left: 6%;
  font-weight: bold;
}
text {
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}
svg {
  display: block;
}
</style>
